import { render, staticRenderFns } from "./DataOverviewModule.vue?vue&type=template&id=7f94f57a&scoped=true"
import script from "./DataOverviewModule.vue?vue&type=script&lang=js"
export * from "./DataOverviewModule.vue?vue&type=script&lang=js"
import style0 from "./DataOverviewModule.vue?vue&type=style&index=0&id=7f94f57a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f94f57a",
  null
  
)

export default component.exports